import { Box, Paper, Stack } from '@mui/material'

import { ConfigVersionInfo } from '@/features/controller/configuration/components/ConfigVersionInfo'
import { ConfigVersionNavigationLinks } from '@/features/controller/configuration/components/ConfigVersionNavigationLinks'
import { TextEditor } from '@/features/controller/configuration/components/textEditor/TextEditor'
import type { ControllerConfigVersion } from '@/features/controller/configuration/types'
import { getControllerConfigType } from '@/features/controller/configuration/utils/controllerConfigTypes'

interface ConfigVersionDisplayReadOnlyProps {
  configVersion: ControllerConfigVersion
  controllerId: string
  onVersionChange?: (versionId: string) => void
}

/**
 * Displaying a config version in read-only mode.
 */
export function ConfigVersionDisplayReadOnly({
  configVersion,
  controllerId,
  onVersionChange,
}: Readonly<ConfigVersionDisplayReadOnlyProps>) {
  const configType = getControllerConfigType(configVersion.configurationTypeId)

  return (
    <Box my={2}>
      <Stack direction="row" gap={2}>
        {/* Main editor section */}
        <Box sx={{ flex: 3 }}>
          <Paper sx={{ p: 5 }}>
            {/* Text Viewer */}
            <TextEditor
              configTypeId={configType.id}
              language={configType.textEditorLanguage}
              value={configVersion.value}
            />
          </Paper>
        </Box>

        {/* Version info section */}
        <Box sx={{ flex: 2 }}>
          <ConfigVersionInfo configVersion={configVersion} controllerId={controllerId} />
          {configVersion.previousVersionId && (
            <ConfigVersionNavigationLinks
              configVersionId={configVersion.id}
              controllerId={controllerId}
              previousVersionId={configVersion.previousVersionId}
              onVersionChange={onVersionChange}
            />
          )}
        </Box>
      </Stack>
    </Box>
  )
}
